// src/pages/Service/ServiceDashboard.jsx
import React from "react";
import { Card, Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { TeamOutlined } from "@ant-design/icons";
import "./serviceDashboard.css"
import { accessChecker } from "../../lib/functions";

const { Title } = Typography;

const ServiceDashboard = () => {
  const navigate = useNavigate();

  const links = [
    { key: "service_entry", title: "Service Entry", value: "service_entry", path: "/service?tab=entry" },
    { key: "service_record", title: "Service Record", value: "service_record", path: "/service?tab=record" },
    { key: "service_voucher", title: "Service Voucher", value: "service_voucher", path: "/service?tab=voucher" },
    { key: "service_return", title: "Service Return Entry", value: "service_return", path: "/service-return?tab=entry" },
    { key: "service_return_record", title: "Service Return Record", value: "service_return_record", path: "/service-return?tab=record" },
    { key: "service_return_voucher", title: "Service Return Voucher", value: "service_return_voucher", path: "/service-return?tab=voucher" },
    { key: "service_expense_entry", title: "Service Expense Entry", value: "service_expense_entry", path: "/service-expense?tab=entry" },
    { key: "service_expense_record", title: "Service Expense Record", value: "service_expense_record", path: "/service-expense?tab=record" },
    { key: "service_expense_voucher", title: "Service Expense Voucher", value: "service_expense_voucher", path: "/service-expense?tab=voucher" },
  ];

  const filteredMenuData = links.filter((menuItem) => accessChecker(menuItem.value));

  return (
    <div className="dashboard-container">
      <Title level={3}>Service Dashboard</Title>
      <Row gutter={[16, 16]}>
        {filteredMenuData?.map((item, i) => (
          <Col xs={24} sm={12} md={8} lg={6} key={i}>
            <Card
              hoverable
              onClick={() => navigate(item.path)}
              className="dashboard-card"
            >
              <TeamOutlined style={{ fontSize: 28, marginBottom: 12 }} />
              <p>{item.title}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ServiceDashboard;
